import { EquipmentFormValues } from 'components/EquipmentDropdown/types';

/**
 * Maps form values to the API expected format
 * @param values Form values from the equipment form
 * @returns Formatted data ready to be sent to the API
 */
export const mapEquipmentFormValuesToApi = (values: EquipmentFormValues) => {
  // Convert date strings to epoch timestamps if they exist
  const currentStatusDateEpoch = values.currentStatusDate
    ? new Date(values.currentStatusDate).getTime()
    : Date.now();

  const purchaseDateEpoch = values.purchaseDate
    ? new Date(values.purchaseDate).getTime()
    : undefined;

  const currentValueDateEpoch = values.currentValueDate
    ? new Date(values.currentValueDate).getTime()
    : undefined;

  // Create valuations array
  const valuations = [];

  // Add purchase valuation if price exists
  if (values.purchasePrice) {
    valuations.push({
      type: 'purchase',
      amount: Number.parseFloat(values.purchasePrice),
      dateEpoch: purchaseDateEpoch || Date.now()
    });
  }

  // Add current valuation if value exists
  if (values.currentValue) {
    valuations.push({
      type: 'current',
      amount: Number.parseFloat(values.currentValue),
      dateEpoch: currentValueDateEpoch || Date.now()
    });
  }

  return {
    id: '',
    name: values.name,
    type: values.type,
    make: values.make,
    model: values.model,
    year: values.year,
    unitId: values.unitId,
    serialNumber: values.serialNumber,
    licenseNumber: values.licenseNumber,
    notes: values.notes,
    services: [],
    valuations: valuations.length > 0 ? valuations : undefined,
    statusHistory: [
      {
        status: values.currentStatus,
        dateEpoch: currentStatusDateEpoch,
        current: true,
        active: true
      }
    ]
  };
};

export default mapEquipmentFormValuesToApi;
